import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
@Injectable({
    providedIn: 'root'
})
export class ScheduleEditService {
    constructor(private https: HttpClient, public errorService: ErrorService) { }

    //................................. SaveSchedule.................................
    SaveSchedule(saveS: any): Observable<any> {
        let url = "api/VisitSchedule/CreateVisitSchedule";
        return this.https.post(url, saveS, { observe: 'response'}).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    getAuthorization(params: URLSearchParams): Observable<any> {
        let url = "api/VisitSchedule/GetAuthSchedules?";
        return this.https.get(url + params, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    getActiveClientRelationshipEmployeeList(params: URLSearchParams): Observable<any> {
        let url = "api/VisitSchedule/GetactiveClientRelationshipEmployeeList?";
        return this.https.get<any>(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    getClientWeekStartAndWeekEnd(params: URLSearchParams): Observable<any> {
        let url = "api/VisitSchedule/getClientWeekStartAndWeekEnd?";
        return this.https.get<any>(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    
    GetServiceDropdown(params: URLSearchParams): Observable<any> {
        let url = "api/VisitSchedule/GetSeviceCodebasedonGroup?";
        return this.https.get<any>(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
}
